import React from "react";
import { GetTeamsFilters } from "@/services/teamService";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UserMultiSelect } from "./UserMultiSelect";

interface TeamFiltersProps {
  filters: GetTeamsFilters;
  onFilterChange: (filters: GetTeamsFilters) => void;
}

const getActiveValue = (isActive: boolean | undefined): string => {
  if (isActive === undefined) {
    return "all";
  }
  return isActive ? "active" : "inactive";
};

export const TeamFilters: React.FC<TeamFiltersProps> = ({
  filters,
  onFilterChange,
}) => {
  const handleStatusChange = (value: string) => {
    const isActive = value === "all" ? undefined : value === "active";
    onFilterChange({ ...filters, isActive });
  };

  const activeValue = getActiveValue(filters.isActive);

  return (
    <div className="flex flex-wrap gap-4 items-center">
      <Select value={activeValue} onValueChange={handleStatusChange}>
        <SelectTrigger className="w-[120px] flex justify-between">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>

      <UserMultiSelect
        selectedUserIds={filters.userIds || []}
        onSelectionChange={(userIds) =>
          onFilterChange({
            ...filters,
            userIds,
          })
        }
      />
    </div>
  );
};
